export const sponsors = {
	USBC: '1',
	NCAA: '2',
	NJCAA:'3',
	NAIA: '4'
}


// WEBPACK FOOTER //
// ./src/utils/constants/sponsors.js